import { TagColor } from "../../../app/data/common/tagColor";
import { InboundProcessingState } from "../../../app/data/communications/models";
import { PickupReviewStatus } from "../../../app/data/communications/models";

export const PROCESSING_STATE_LABELS: Record<InboundProcessingState, string> = {
  RECEIVED: "Received",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

export const PROCESSING_STATE_COLORS: Record<InboundProcessingState, TagColor> = {
  RECEIVED: TagColor.GREY,
  PROCESSING: TagColor.BLUE,
  COMPLETED: TagColor.GREEN,
  FAILED: TagColor.RED,
};

export const REVIEW_STATUS_LABELS: Record<PickupReviewStatus, string> = {
  REQUIRE_HUMAN_REVIEW: "Needs review",
  APPROVED_BY_HUMAN: "Approved",
  REJECTED_BY_HUMAN: "Rejected",
  APPROVED_BY_SYSTEM: "Auto-approved",
  REJECTED_BY_SYSTEM: "Auto-rejected",
};

export const REVIEW_STATUS_COLORS: Record<PickupReviewStatus, TagColor> = {
  REQUIRE_HUMAN_REVIEW: TagColor.ORANGE,
  APPROVED_BY_HUMAN: TagColor.GREEN,
  REJECTED_BY_HUMAN: TagColor.RED,
  APPROVED_BY_SYSTEM: TagColor.GREEN,
  REJECTED_BY_SYSTEM: TagColor.RED,
};

export const formatRequestType = (type: string): string =>
  type
    .split("_")
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ");

/** Tag label for non-complete processing states, e.g. "Processing - Failed" */
export const formatProcessingStatusTag = (state: InboundProcessingState): string | null => {
  if (state === "COMPLETED") return null;
  return `Processing - ${PROCESSING_STATE_LABELS[state]}`;
};
